<div id="container" class="l-constrained">
  <div *ngIf="langSelector === 'es'; else engHeader"><app-nav-main-sp></app-nav-main-sp></div>
  <ng-template #engHeader><app-nav-main></app-nav-main></ng-template>

  <router-outlet></router-outlet>

  <div id="footer" class="clearfix sticky-footer l-constrained">
  <div *ngIf="langSelector === 'es'; else engFooter"><app-footer-sp></app-footer-sp></div>
    <ng-template #engFooter><app-footer></app-footer></ng-template>
  </div>
</div>